import React, { createContext, useState, useEffect, useContext } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [orgId, setOrgId] = useState(null);
  const [role, setRole] = useState("member");
  const [orgPlan, setOrgPlan] = useState("starter");

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) {
        setUser(null);
        setOrgId(null);
        setRole("member");
        setOrgPlan("starter");
        return;
      }

      setUser(u);

      try {
        const userDoc = await getDoc(doc(db, "users", u.uid));
        if (!userDoc.exists()) return;

        const userData = userDoc.data();
        const org = userData.currentOrgId || userData.orgId || (userData.orgIds && userData.orgIds[0]);
        setOrgId(org);

        const orgDoc = await getDoc(doc(db, "organizations", org));
        const plan = orgDoc.exists() ? orgDoc.data().plan || "starter" : "starter";
        setOrgPlan(plan);

        const roleInOrg = userData.roles?.[org] || "member";
        setRole(roleInOrg);
      } catch (err) {
        console.error("Fehler beim Laden des Users/Orgs:", err);
      }
    });

    return () => unsub();
  }, []);

  return (
    <UserContext.Provider value={{ user, orgId, role, orgPlan }}>
      {children}
    </UserContext.Provider>
  );
};

// Hook zum einfachen Zugriff
export const useUser = () => useContext(UserContext);
